module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStart),
      expression: "isStart"
    }],
    staticClass: "game-container"
  }, [_c('div', {
    ref: "player",
    staticClass: "player",
    style: ({
      bottom: (_vm.playerBottom + "px")
    })
  }, [_c('img', {
    attrs: {
      "src": ("/static/img/" + _vm.imgType + ".png")
    }
  })]), _c('div', {
    staticClass: "game-main-window"
  }, [_c('div', {
    ref: "gameWrapper",
    staticClass: "game-wrapper",
    style: ({
      transform: ("translate(" + (-_vm.blockPosition) + "px, 0)")
    })
  }, _vm._l((_vm.blocks), function(b) {
    return _c('div', {
      staticClass: "block",
      style: (b)
    })
  }))]), _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "time"
  }, [_vm._v("TIMES: " + _vm._s((_vm.currentTime.getTime() - _vm.startTime.getTime()) / 1000))])]), _c('div', {
    staticClass: "stop"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("BACK")])]), _c('div', {
    staticClass: "over-mask",
    style: ({
      opacity: _vm.gameOverOpacity
    })
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isStart),
      expression: "!isStart"
    }],
    staticClass: "game-container"
  }, [_c('h1', {
    staticClass: "desc"
  }, [_vm._v("八分音符 HTML5 版本")]), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.start
    }
  }, [_vm._v("开始游戏")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-675f0e05"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 86
// module chunks = 1